var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkPlus = function SvgLinkPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.911.18a9.096 9.096 0 0 1 1.36 18.087 6.816 6.816 0 0 0-9.933-5.968 9.1 9.1 0 0 1-.518-3.026C1.82 4.251 5.89.18 10.911.18m3.255 6.453c-.533-.4-1.226-.19-1.226.521v1.332H5.368a.78.78 0 0 0-.794.772c0 .44.352.792.794.792h7.572v1.342c0 .69.673.942 1.226.521l2.806-2.104a.65.65 0 0 0 0-1.062z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.455 23.82A5.464 5.464 0 0 1 0 18.364a5.46 5.46 0 0 1 5.455-5.455 5.457 5.457 0 0 1 5.454 5.455 5.46 5.46 0 0 1-5.454 5.454m-2.61-5.45c0 .273.192.455.47.455H4.99v1.679c0 .272.187.47.46.47a.45.45 0 0 0 .47-.47v-1.68H7.6c.273 0 .47-.181.47-.454a.45.45 0 0 0-.47-.47h-1.68v-1.674a.453.453 0 0 0-.47-.476c-.273 0-.46.198-.46.476V17.9H3.316a.45.45 0 0 0-.471.47"
  })));
};
export default SvgLinkPlus;